import React, { useState, useContext } from 'react';
import './TaxCalculator.css';
import { ThemeContext } from '../App';
import SalesTaxCalculator from './SalesTaxCalculator';
import IncomeTaxCalculator from './IncomeTaxCalculator';
import PropertyTaxCalculator from './PropertyTaxCalculator';
import TaxInfoPanel from './TaxInfoPanel';

function TaxCalculator() {
    const { darkMode } = useContext(ThemeContext);
    const [activeTab, setActiveTab] = useState('sales');

    // Tab handling
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div className={`calculator ${darkMode ? 'dark-mode' : ''}`}>
            <div className="card">
                <div className="card-header">
                    <h2>New Jersey Tax Calculator</h2>
                    <div className="tabs">
                        <button 
                            className={`tab-button ${activeTab === 'sales' ? 'active' : ''}`}
                            onClick={() => handleTabChange('sales')}
                        >
                            Sales Tax
                        </button>
                        <button 
                            className={`tab-button ${activeTab === 'income' ? 'active' : ''}`}
                            onClick={() => handleTabChange('income')}
                        >
                            Income Tax
                        </button>
                        <button 
                            className={`tab-button ${activeTab === 'property' ? 'active' : ''}`}
                            onClick={() => handleTabChange('property')}
                        >
                            Property Tax
                        </button>
                        <button 
                            className={`tab-button ${activeTab === 'info' ? 'active' : ''}`}
                            onClick={() => handleTabChange('info')}
                        >
                            Tax Info
                        </button>
                    </div>
                </div>
                
                <div className="card-body">
                    {activeTab === 'sales' && <SalesTaxCalculator />}
                    {activeTab === 'income' && <IncomeTaxCalculator />}
                    {activeTab === 'property' && <PropertyTaxCalculator />}
                    {activeTab === 'info' && <TaxInfoPanel />}
                </div>
            </div>
        </div>
    );
}

export default TaxCalculator;
